import { render, staticRenderFns } from "./EditAdditionallyInfoClient.vue?vue&type=template&id=7d5c89ab&"
import script from "./EditAdditionallyInfoClient.vue?vue&type=script&lang=js&"
export * from "./EditAdditionallyInfoClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports